import React, { useState } from 'react';
import ModalDialog from '../../../../oldPage/newpage/tools/Modal/Modal';
import './progressImageShow.css'
import { Modal } from 'antd';


export function useProgressImageShow(imgs: {
    src: string,
    width: number,
    height: number,
}[], imgPath: {
    filenames: string[],
    qcfilepath: string
}) {
    const [showNumber, setNumber] = useState(-1);


    function createTools(title: JSX.Element) {
        return (
            <>
                <button className="progress-img-show-btn progress-img-show-left-btn" disabled={showNumber <= 0} >
                    <div className="right-arrow" />
                </button>
                {title}
                <button className="progress-img-show-btn progress-img-show-right-btn" disabled={showNumber >= imgs.length - 1} >
                    <div className="left-arrow" />
                </button>
            </>
        )
    }


    // let jsx = (
    //     <ModalDialog
    //         protalId={"modal-root"}
    //         title={showNumber > -1 ? imgPath.filenames[showNumber] : ""} enable={showNumber > -1}
    //         onClick={() => { setNumber(-1) }}
    //         tools={createTools}
    //     >

    //         <div className="progress-image-show">
    //             <img src={showNumber > -1 ? imgs[showNumber].src : ""} alt={showNumber > -1 ? imgPath.filenames[showNumber] : ""} height={showNumber > -1 ? imgs[showNumber].height / 3 : ""} />
    //         </div>
    //     </ModalDialog>
    // )
    let jsx = (
        showNumber > -1 ?
            <Modal
                style={{ display: 'flex', width: 600 }}
                title="Basic Modal"
                visible={true}
                footer={null}
                onCancel={() => {
                    setNumber(-1)
                }} //width: 50,height: 50,lineHeight: 50,background: '#ccc',textAlign: 'center',borderRadius: '50%',opacity: '0.5'
            >

                <div style={{ display: 'flex' }}>
                    {
                        showNumber <= 0 ? <div style={{marginTop: '40%', fontSize: 22, width: 45, height: 45, textAlign: 'center', }}></div> : <div style={{ cursor: 'pointer',marginTop: '40%', fontSize: 22, width: 45, height: 45, background: '#ccc', textAlign: 'center', borderRadius: '50%', opacity: '0.3' }} onClick={() => {
                        
                        setNumber(showNumber - 1)
                    }} >
                        {'<'}
                    </div>
                    }
                    
                    <div className="progress-image-show">
                        <img src={showNumber > -1 ? imgs[showNumber].src : ""} alt={showNumber > -1 ? imgPath.filenames[showNumber] : ""} height={showNumber > -1 ? imgs[showNumber].height / 3 : ""} />
                    </div>
                    {
                        showNumber >= imgs.length - 1 ? <div style={{ marginTop: '40%', fontSize: 22, width: 45, height: 45, textAlign: 'center',  }}> </div> :  <div style={{cursor: 'pointer', marginTop: '40%', fontSize: 22, width: 45, height: 45, background: '#ccc', textAlign: 'center', borderRadius: '50%', opacity: '0.3' }} onClick={() => {
                        if (showNumber >= imgs.length - 1) {
                            return
                        }
                        setNumber(showNumber + 1)
                    }}>
                        {'>'}
                    </div>
                    }
                   
                </div>
            </Modal>
            : ''

    )
    let show = (index: number) => { setNumber(index) }

    return [show, jsx] as [(index: number) => void, JSX.Element]

}